/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { memo, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  addCustomerAsync,
  deleteCustomersAsync,
  demoteSubadminAsync,
  fetchAllCustomersAsync,
  promoteCustomerAsync,
  resetCustomersPasswordAsync,
  selectCustomers,
  suspendCustomerAsync,
  unsuspendCustomerAsync,
} from './customers.slice';
import { selectAuth } from '../auth/auth.slice';
import CustomersView from './allcustomers.view';
import { actions as appActions } from '../app/app.slice';
import { IGetCustomersArgs } from './customers.api';

export interface ICustomersContainer {}

const CustomersContainer: React.FC<ICustomersContainer> = ({}: ICustomersContainer) => {
  const customers = useAppSelector(selectCustomers);
  const auth = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAllCustomersAsync({}));
  }, []);

  useEffect(() => {
    dispatch(appActions.setLocationCode('10107'));
  }, []);

  const handleAddCustomer = (data: any) => {
    dispatch(addCustomerAsync(data));
  };

  const handleDeleteCustomer = (id: string) => {
    dispatch(deleteCustomersAsync(id));
  };

  const handlePromoteCustomer = (id: string) => {
    dispatch(promoteCustomerAsync(id));
  };

  const handleDemoteSubadmin = (id: string) => {
    dispatch(demoteSubadminAsync(id));
  };

  const handleRestCustomerPassword = (data: any) => {
    navigator.clipboard.writeText(data.password);
    dispatch(resetCustomersPasswordAsync(data));
  };

  const handleSuspendCustomer = (id: string) => {
    dispatch(
      suspendCustomerAsync({
        id,
        nextApiCallType: 'fetchAllCustomers',
      })
    );
  };

  const handleUnsuspendCustomer = (id: string) => {
    dispatch(
      unsuspendCustomerAsync({
        id,
        nextApiCallType: 'fetchAllCustomers',
      })
    );
  };

  const handleGetCustomers = (data: IGetCustomersArgs) => {
    dispatch(fetchAllCustomersAsync(data));
  };

  return (
    <CustomersView
      selectCustomer={customers}
      customersList={customers.list}
      permissions={auth.permissions}
      handleAddCustomer={handleAddCustomer}
      handleDeleteCustomer={handleDeleteCustomer}
      handleRestCustomerPassword={handleRestCustomerPassword}
      handlePromoteCustomer={handlePromoteCustomer}
      handleDemoteSubadmin={handleDemoteSubadmin}
      handleSuspendCustomer={handleSuspendCustomer}
      handleUnsuspendCustomer={handleUnsuspendCustomer}
      handleGetCustomers={handleGetCustomers}
    />
  );
};

export default memo(CustomersContainer);
